/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ToolUsageUserTimeSeriesPoint,
  ToolUsageUserTimeSeriesPoint$inboundSchema,
} from "./toolusageusertimeseriespoint.js";

/**
 * Time-series MCP and tool usage grouped by user identity
 */
export type GetToolUsageUserTimeSeriesResult = {
  /**
   * Time-series usage buckets grouped by user identity
   */
  userTimeSeries: Array<ToolUsageUserTimeSeriesPoint>;
};

/** @internal */
export const GetToolUsageUserTimeSeriesResult$inboundSchema: z.ZodMiniType<
  GetToolUsageUserTimeSeriesResult,
  unknown
> = z.pipe(
  z.object({
    user_time_series: z.array(ToolUsageUserTimeSeriesPoint$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "user_time_series": "userTimeSeries",
    });
  }),
);

export function getToolUsageUserTimeSeriesResultFromJSON(
  jsonString: string,
): SafeParseResult<GetToolUsageUserTimeSeriesResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetToolUsageUserTimeSeriesResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetToolUsageUserTimeSeriesResult' from JSON`,
  );
}
